import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-name-meaning" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", {
        textContent: _toDisplayString(_ctx.resData.name)
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createElementVNode("p", {
        textContent: _toDisplayString(_ctx.resData.meaning)
      }, null, 8, _hoisted_5)
    ])
  ]))
}